export default __webpack_public_path__ + "static/media/package-icon.a8ce8c55.svg";